var map = {
	"./m-0-cur.png": "04bc",
	"./m-1-cur.png": "834b",
	"./m-2-cur.png": "6734",
	"./m-3-cur.png": "35ba",
	"./m-4-cur.png": "5561",
	"./m-5-cur.png": "1b36",
	"./m-6-cur.png": "3f57",
	"./m-7-cur.png": "f583",
	"./m-8-cur.png": "9ecb",
	"./no-selected.png": "6b73"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "754c";